"use client";

import type { ReactNode } from "react";
import { useTranslations } from "next-intl";

const ITEM_KEYS = ["shipping", "kit", "ruo"] as const;

function AnnouncementIcon({ name }: { name: (typeof ITEM_KEYS)[number] }) {
	const cls = "h-3 w-3 shrink-0 text-white/70";
	switch (name) {
		default:
			return (
				<svg
					aria-hidden
					viewBox="0 0 16 16"
					className={cls}
					fill="none"
					stroke="currentColor"
					strokeWidth="1.2"
					strokeLinejoin="round"
					strokeLinecap="round"
				>
					<rect x="1" y="4" width="9" height="6" />
					<path d="M10 6 H13 L15 8.5 V10 H10 Z" />
					<circle cx="4" cy="12" r="1.4" />
					<circle cx="12" cy="12" r="1.4" />
				</svg>
			);
	}
}

export function AnnouncementBar({ campaign }: { campaign?: ReactNode }) {
	const tNav = useTranslations("nav.announcement");
	const tKit = useTranslations("kitWebsite");
	const tCatalog = useTranslations("catalog.researchUseBadge");
	const track = [...ITEM_KEYS, ...ITEM_KEYS];

	if (campaign) return <div className="border-primary/20 border-b bg-primary-hero">{campaign}</div>;

	return (
		<div className="border-primary/20 group relative overflow-hidden border-b bg-primary-hero text-white/85">
			<div className="group-hover:[animation-play-state:paused] flex animate-marquee whitespace-nowrap">
				{track.map((key, i) => (
					<span
						key={`${key}-${i}`}
						className="flex shrink-0 items-center gap-2 px-6 py-2 font-mono text-[0.62rem] uppercase tracking-[0.22em]"
					>
						<AnnouncementIcon name={key} />
						{key === "shipping"
							? tNav("shipping")
							: key === "kit"
								? tKit("unit.short")
								: tCatalog("bannerPrimary")}
						<span className="ml-6 text-white/30">·</span>
					</span>
				))}
			</div>
		</div>
	);
}
